module.exports = "/assets/data/96c26ddae5b8bfc44a0231332a7f47c8-BT67.data.json";